export default "__VITE_ASSET__BukWmZqm__"